/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'react',
	'react-dom',
	'require',
	'./ReactToolbar',
	'../toolbar_components/NextView'
], function(View, React, ReactDOM, require, ReactToolbar, NextView) {

	var ReactToolbarContainer = View.extend({

		init: function(itemSpecs, el, toolbar) {
			ReactToolbarContainer.inherited('init', this, arguments);
			this.itemSpecs = itemSpecs;
			this.el = el;
			this._toolbar = toolbar;
		},

		getItems: function() {
			return this.itemSpecs;
		},

		setFocus: function() {
			const firstButton = this._toolbar.$el.find('button')[0];
			if (firstButton) {
				firstButton.focus();
			}
		},

		_nextViewCb: (that, itemSpec, evt, updateButton) => {
			that._toolbar.updateButtons = updateButton;
			const nextView = new NextView(itemSpec, null, that._toolbar);
			nextView.initializeNextView(evt);
			return nextView;
		},

		ready: function(orientation) {
			return new Promise((resolve) => {
				ReactDOM.render(
					<ReactToolbar
						itemSpecs={this.getItems()}
						orientation={orientation}
						nextViewCb={(itemSpec, evt, updateButton) => this._nextViewCb(this, itemSpec, evt, updateButton)}
						toolbarOptions={this._toolbar.options}
						toolbar={this._toolbar}
					/>,
					this.el,
					() => {
						resolve();
					}
				);
			});
		},

		clearItems: function() {
			this.itemSpecs = [];
			ReactDOM.unmountComponentAtNode(this.el);
		}
	});

	return ReactToolbarContainer;
});
